import React, {useEffect, useState} from "react";
import Icon from 'react-web-vector-icons';

import './FieldGroup.scss';

const FieldGroup = props => {
	const {title, children, expandable, expanded, isCustomGrid} = props;
	const [isExpanded, setIsExpanded] = useState(expandable == null || expanded);

	useEffect(() => {
		const load = async () => {

		};
		load();
	}, []);

	return (
		<div className="fieldGroup-container">
			{
				expandable ?
					<div onClick={() => setIsExpanded(!isExpanded)} className="fieldGroup-title-expandable">
						<Icon
							name={isExpanded ? 'chevron-small-down' : 'chevron-small-up'}
							font='Entypo'
							color="black"
							size={20}
							style={{padding: '0 5px'}}
						/>
						{title}
					</div>
					:
					<div className="fieldGroup-title">
						{title}
					</div>
			}
			<div
				style={isExpanded ? (isCustomGrid ? {} : {display: 'grid', gridTemplateColumns: '1fr 1fr'}) : {display: 'none'}}
			>
				{children}
			</div>
		</div>
	)
};

export default FieldGroup;